import { render, staticRenderFns } from "./Stap5b.vue?vue&type=template&id=6e967d46&"
import script from "./Stap5b.vue?vue&type=script&lang=js&"
export * from "./Stap5b.vue?vue&type=script&lang=js&"
import style0 from "./Stap5b.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports